const STORAGE_KEY = "affiliate-id";
const getStoredAffiliateId = () => {
  const isClient = typeof window !== "undefined";
  if (!isClient) {
    return "";
  }
  const json = window.sessionStorage.getItem(STORAGE_KEY);
  const affiliateId = json ? JSON.parse(json) : void 0;
  return affiliateId;
};
const setStoredAffiliateId = (id) => {
  const isClient = typeof window !== "undefined";
  if (!isClient || !id?.length) {
    return false;
  }
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(id));
  return true;
};
const clearStoredAffiliateId = () => {
  const isClient = typeof window !== "undefined";
  if (!isClient) {
    return false;
  }
  window.sessionStorage.removeItem(STORAGE_KEY);
  return true;
};
export {
  clearStoredAffiliateId,
  getStoredAffiliateId,
  setStoredAffiliateId
};
//# sourceMappingURL=affiliate-id-storage.js.map
